// @ts-nocheck
import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  Text,
  AutoSavedSwitcherControl,
  Stack,
  Card,
  Trans,
  withTranslation,
  Tooltip,
  Icon,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

export interface KeepUrlFragmentProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class KeepUrlFragment extends React.Component<KeepUrlFragmentProps> {
  constructor(props: KeepUrlFragmentProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'keep_url_fragment',
        settings.attributes.keep_url_fragment,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <Card.Section>
        <Stack wrap verticalAlignment="center">
          <Stack.Item fill>
            <Stack vertical spacing="narrow">
              <Stack.Item>
                <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">
                  {t('apps.details.settings.tracking.keep-page-url.title')}
                  <div style={{ display: 'inline-block', marginLeft: '8px' }}>
                    <Tooltip
                      content={(
                        <Trans
                          i18nKey="apps.details.settings.tracking.keep-page-url.tooltip"
                          components={[
                            <b>text</b>,
                          ]}
                        />
                      )}
                    >
                      <div><Icon name="info-circle" /></div>
                    </Tooltip>
                  </div>
                </Text>
              </Stack.Item>
              <Stack.Item>
                <Text as="p">{t('apps.details.settings.tracking.keep-page-url.description')}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          {!failed && (
            <Stack.Item>
              <AutoSavedSwitcherControl
                id="app-settings-tracking-keep-url-fragment"
                initialValue={settings.attributes.keep_url_fragment}
                name="keep_url_fragment"
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage condensed />}
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(KeepUrlFragment as any));
